var exports = {
  "U": "xdde3148b--082b96--name",
  "W": "xdde3148b--082b96--factoids",
};

module.exports = exports;
